import React from 'react';
import { useLocalSearchParams } from 'expo-router';
import MetaHead from '@/components/MetaHead';
import { promptApi as promptApiSsr } from '@/lib/promptApi';
import { PromptsPage } from '@/app/(app)/prompts/index';

// Category routes are browse filters only — not indexed (hub + detail pages carry SEO).
export async function generateStaticParams() {
  // Rendered on demand (client SPA), not prerendered. This route is noindex.
  return [];
}

export default function PromptsCategoryRoute() {
  const params = useLocalSearchParams();
  const slug =
    typeof params?.slug === 'string'
      ? params.slug
      : Array.isArray(params?.slug)
        ? params.slug[0]
        : null;

  return (
    <>
      <MetaHead
        noindex
        canonical={slug ? `/prompts/category/${slug}` : '/prompts'}
      />
      <PromptsPage categorySlug={slug || undefined} />
    </>
  );
}
